// Rótulos y valores de la columna «Crédito SK» de «A quién le aplica».
export const ANY_CUSTOMER_LABEL = 'Cualquier cliente';
export const SK_CREDIT_REQUIRED_LABEL = 'Solo con crédito SK activo';
export const SK_CREDIT_REQUIRED = 'REQUIRED';
